import type { WorkspaceApp } from "@bafe/types";

export const APP_OPTIONS: Array<{ id: WorkspaceApp; label: string; detail: string }> = [
	{ id: "hub", label: "Hub", detail: "Tasks, people, sales and the rest of the business." },
	{ id: "mail", label: "Mail", detail: "Mailboxes, aliases, forwarders and migration." },
	{ id: "site", label: "Site", detail: "Sites, databases and redirects." },
	{ id: "team", label: "Team", detail: "Channels and direct messages for people in this workspace." },
	{ id: "social", label: "Social", detail: "Draft, approve and schedule posts on connected brand accounts." },
	{
		id: "engage",
		label: "Engage",
		detail: "One inbox for WhatsApp, Telegram, Facebook Messenger, Instagram, Threads, X, TikTok and LinkedIn.",
	},
];
